import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";

const AdminEnrollments = () => {
  const [enrollments, setEnrollments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const snap = await getDocs(collection(db, "enrollments"));
        setEnrollments(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch (e) { console.error(e); }
      setLoading(false);
    };
    fetch();
  }, []);

  return (
    <div data-testid="admin-enrollments">
      <div className="mb-8">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-blue-600 mb-2">Enrollments</div>
        <h1 className="font-heading text-3xl font-bold tracking-tight text-slate-900">All Enrollments</h1>
        <p className="mt-1 text-slate-600">{enrollments.length} total enrollments</p>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
        {loading ? (
          <div className="p-10 text-center text-slate-500">Loading...</div>
        ) : enrollments.length === 0 ? (
          <div className="p-10 text-center text-slate-500" data-testid="no-enrollments">No enrollments yet.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-600">
              <tr>
                <th className="text-left px-6 py-3 font-semibold">Student ID</th>
                <th className="text-left px-6 py-3 font-semibold">Course</th>
                <th className="text-left px-6 py-3 font-semibold">Batch</th>
                <th className="text-left px-6 py-3 font-semibold">Progress</th>
                <th className="text-left px-6 py-3 font-semibold">Attendance</th>
                <th className="text-left px-6 py-3 font-semibold">Status</th>
              </tr>
            </thead>
            <tbody>
              {enrollments.map((e) => (
                <tr key={e.id} className="border-t border-slate-100">
                  <td className="px-6 py-3 font-mono text-xs">{e.studentId}</td>
                  <td className="px-6 py-3 text-slate-900">{e.courseTitle || e.courseId}</td>
                  <td className="px-6 py-3 text-slate-700">{e.batchId}</td>
                  <td className="px-6 py-3">{e.progress || 0}%</td>
                  <td className="px-6 py-3">{e.attendancePercentage || 0}%</td>
                  <td className="px-6 py-3">
                    <span className="px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 text-xs font-semibold capitalize">
                      {e.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminEnrollments;
